import globals from "@lvt/globals";
import { createApi } from "@reduxjs/toolkit/query/react";

import { vmsBaseQuery } from "@/api/vmsBase";
import { LiveUnitMosaicData } from "@/utilities/types/mosaicData";


interface PresetUpdate {
    liveUnitId: number;
    presetId: number;
    name: string;
}

interface PresetAdd {
    liveUnitId: number;
    cameraId: number;
    name: string;
}

export const liveUnitMosaicApi = createApi({
    reducerPath: "liveUnitMosaic",
    baseQuery: vmsBaseQuery(globals.userdashboard.proxyUrl),
    endpoints: (builder) => ({
        liveUnitMosaicData: builder.query<LiveUnitMosaicData, number>({
            query: (liveUnitId) => ({
                url: `/api/vms/mosaic/live_unit/${liveUnitId}`,
                method: "GET",
            }),
        }),
        addPreset: builder.mutation<number, PresetAdd>({
            query: ({ cameraId, name }) => ({
                url: "/api/vms/presets",
                method: "POST",
                body: {
                    cameraId,
                    name,
                },
            }),
            onCacheEntryAdded: (presetAdd, { dispatch, cacheDataLoaded }) => {
                cacheDataLoaded
                    .then(({ data: id }) => {
                        dispatch(
                            liveUnitMosaicApi.util.updateQueryData("liveUnitMosaicData", presetAdd.liveUnitId, (draft) => {
                                draft.cameras.forEach((camera) => {
                                    if (camera.cameraId === presetAdd.cameraId) {
                                        camera.presets.push({
                                            id: id,
                                            name: presetAdd.name,
                                            isHome: false,
                                        });
                                    }
                                });
                            }),
                        );
                    });
            },
        }),
        updatePreset: builder.mutation<string, PresetUpdate>({
            query: ({ presetId, name }) => ({
                url: `/api/vms/presets/${presetId}`,
                method: "PUT",
                body: {
                    name,
                },
            }),
            onCacheEntryAdded: (presetUpdate, { dispatch }) => {
                dispatch(
                    liveUnitMosaicApi.util.updateQueryData("liveUnitMosaicData", presetUpdate.liveUnitId, (draft) => {
                        draft.cameras.forEach((camera) => {
                            camera.presets.forEach((preset) => {
                                if (preset.id === presetUpdate.presetId) {
                                    preset.name = presetUpdate.name;
                                }
                            });
                        });
                    }),
                );
            },
        }),
    }),
});

export const { useLiveUnitMosaicDataQuery, useAddPresetMutation, useUpdatePresetMutation } = liveUnitMosaicApi;
